import { render, staticRenderFns } from "./izyzInformation.vue?vue&type=template&id=2c17a316&scoped=true&"
import script from "./izyzInformation.vue?vue&type=script&lang=js&"
export * from "./izyzInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c17a316",
  null
  
)

component.options.__file = "izyzInformation.vue"
export default component.exports